@if (visible()) {
  <div class="formSection" [id]="section.code">
    @if (componentToRender(); as cmp) {
      <ng-container *ngComponentOutlet="cmp; inputs: { section: section }"></ng-container>
    }
  </div>
}
